function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 1.75134C3.91592 1.75134 1 4.66727 1 8.25134C1 11.8354 3.91592 14.7513 7.5 14.7513C11.0841 14.7513 14 11.8354 14 8.25134C14 4.66727 11.0841 1.75134 7.5 1.75134ZM7.5 2.72634C10.5571 2.72634 13.025 5.19419 13.025 8.25134C13.025 11.3085 10.5571 13.7763 7.5 13.7763C4.44285 13.7763 1.975 11.3085 1.975 8.25134C1.975 5.19419 4.44285 2.72634 7.5 2.72634ZM7.5 5.00134C7.32761 5.00134 7.16228 5.06982 7.04038 5.19172C6.91848 5.31362 6.85 5.47895 6.85 5.65134C6.85 5.82373 6.91848 5.98906 7.04038 6.11096C7.16228 6.23286 7.32761 6.30134 7.5 6.30134C7.67239 6.30134 7.83772 6.23286 7.95962 6.11096C8.08152 5.98906 8.15 5.82373 8.15 5.65134C8.15 5.47895 8.08152 5.31362 7.95962 5.19172C7.83772 5.06982 7.67239 5.00134 7.5 5.00134ZM7.49238 7.26936C7.3632 7.27138 7.2401 7.32459 7.15012 7.4173C7.06015 7.51002 7.01065 7.63466 7.0125 7.76384V11.3388C7.01159 11.4034 7.02352 11.4676 7.04761 11.5275C7.0717 11.5875 7.10746 11.642 7.15282 11.688C7.19818 11.734 7.25223 11.7706 7.31183 11.7955C7.37143 11.8204 7.43539 11.8333 7.5 11.8333C7.56461 11.8333 7.62857 11.8204 7.68817 11.7955C7.74777 11.7706 7.80182 11.734 7.84718 11.688C7.89254 11.642 7.9283 11.5875 7.95239 11.5275C7.97648 11.4676 7.98841 11.4034 7.9875 11.3388V7.76384C7.98844 7.69859 7.97626 7.63382 7.9517 7.57336C7.92715 7.5129 7.8907 7.45799 7.84453 7.41188C7.79836 7.36577 7.7434 7.32939 7.68291 7.30491C7.62242 7.28043 7.55763 7.26834 7.49238 7.26936Z",
  fill: "#515055"
});

function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.0916d2fd89d426184cc4d292e352ede8.svg";
export { ForwardRef as ReactComponent };